export default __webpack_public_path__ + "media/images/logo-cd0094fe73708e22b6ddbb46754572fd.svg";